<template>
  <v-tooltip location="left">
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        icon
        elevation="4"
        class="feedback-tab"
        color="primary"
        :disabled="disabled"
        @click.stop="handleClick"
      >
        <v-icon>mdi-comment-text-outline</v-icon>
      </v-btn>
    </template>
    <span>Feedback</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'FeedbackTab',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle'],
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit('toggle')
      }
    },
  },
}
</script>

<style scoped>
.feedback-tab {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  border-radius: 8px 0 0 8px;
  width: 48px;
  min-width: 48px;
  height: 80px;
}

/* Narrow viewports: sit higher so stacked right-edge controls (e.g. edit) are not covered */
@media (max-width: 959.98px) {
  .feedback-tab {
    top: 30%;
  }
}

@media print {
  .feedback-tab {
    display: none !important;
  }
}
</style>

